module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.74e92ab3.jpeg";